import { render, staticRenderFns } from "./AccountWishlist.vue?vue&type=template&id=3e83d96e&scoped=true&"
import script from "./AccountWishlist.vue?vue&type=script&lang=js&"
export * from "./AccountWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e83d96e",
  null
  
)

export default component.exports